/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PrivateImport } from './routes/_private'
import { Route as IndexImport } from './routes/index'
import { Route as PublicAuthImport } from './routes/_public/_auth'
import { Route as PrivateDashboardImport } from './routes/_private/_dashboard'
import { Route as PrivateMeetingsIdIndexImport } from './routes/_private/meetings/$id/index'
import { Route as PrivateDashboardMeetingsIndexImport } from './routes/_private/_dashboard/meetings/index'
import { Route as PrivateDashboardBeneficiariesIdImport } from './routes/_private/_dashboard/beneficiaries/$id'
import { Route as PublicAuthAuthResetPasswordIndexImport } from './routes/_public/_auth/auth/reset-password/index'
import { Route as PrivateMeetingsIdReportIndexImport } from './routes/_private/meetings/$id/report/index'
import { Route as PrivateDashboardBeneficiariesIdTabsImport } from './routes/_private/_dashboard/beneficiaries/$id/_tabs'
import { Route as PrivateDashboardBeneficiariesIdTabsProgramIndexImport } from './routes/_private/_dashboard/beneficiaries/$id/_tabs/program/index'

// Create Virtual Routes

const PublicLazyImport = createFileRoute('/_public')()
const PrivateAuthSuccessIndexLazyImport = createFileRoute(
  '/_private/auth/success/',
)()
const PrivateDashboardProfileIndexLazyImport = createFileRoute(
  '/_private/_dashboard/profile/',
)()
const PrivateDashboardDashboardIndexLazyImport = createFileRoute(
  '/_private/_dashboard/dashboard/',
)()
const PublicAuthAuthLoginIndexLazyImport = createFileRoute(
  '/_public/_auth/auth/login/',
)()
const PublicAuthAuthForgotPasswordIndexLazyImport = createFileRoute(
  '/_public/_auth/auth/forgot-password/',
)()
const PublicAuthAuthRegisterTokenIndexLazyImport = createFileRoute(
  '/_public/_auth/auth/register/$token/',
)()
const PrivateDashboardBeneficiariesIdTabsIndexLazyImport = createFileRoute(
  '/_private/_dashboard/beneficiaries/$id/_tabs/',
)()
const PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyImport =
  createFileRoute('/_private/_dashboard/beneficiaries/$id/_tabs/tracking/')()
const PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyImport =
  createFileRoute('/_private/_dashboard/beneficiaries/$id/_tabs/telecare/')()
const PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyImport =
  createFileRoute('/_private/_dashboard/beneficiaries/$id/_tabs/program/new/')()

// Create/Update Routes

const PublicLazyRoute = PublicLazyImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/_public.lazy').then((d) => d.Route))

const PrivateRoute = PrivateImport.update({
  id: '/_private',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/_private.lazy').then((d) => d.Route))

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PublicAuthRoute = PublicAuthImport.update({
  id: '/_auth',
  getParentRoute: () => PublicLazyRoute,
} as any).lazy(() => import('./routes/_public/_auth.lazy').then((d) => d.Route))

const PrivateDashboardRoute = PrivateDashboardImport.update({
  id: '/_dashboard',
  getParentRoute: () => PrivateRoute,
} as any)

const PrivateAuthSuccessIndexLazyRoute =
  PrivateAuthSuccessIndexLazyImport.update({
    id: '/auth/success/',
    path: '/auth/success/',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./routes/_private/auth/success/index.lazy').then((d) => d.Route),
  )

const PrivateDashboardProfileIndexLazyRoute =
  PrivateDashboardProfileIndexLazyImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => PrivateDashboardRoute,
  } as any).lazy(() =>
    import('./routes/_private/_dashboard/profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateDashboardDashboardIndexLazyRoute =
  PrivateDashboardDashboardIndexLazyImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => PrivateDashboardRoute,
  } as any).lazy(() =>
    import('./routes/_private/_dashboard/dashboard/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateMeetingsIdIndexRoute = PrivateMeetingsIdIndexImport.update({
  id: '/meetings/$id/',
  path: '/meetings/$id/',
  getParentRoute: () => PrivateRoute,
} as any).lazy(() =>
  import('./routes/_private/meetings/$id/index.lazy').then((d) => d.Route),
)

const PrivateDashboardMeetingsIndexRoute =
  PrivateDashboardMeetingsIndexImport.update({
    id: '/meetings/',
    path: '/meetings/',
    getParentRoute: () => PrivateDashboardRoute,
  } as any)

const PrivateDashboardBeneficiariesIdRoute =
  PrivateDashboardBeneficiariesIdImport.update({
    id: '/beneficiaries/$id',
    path: '/beneficiaries/$id',
    getParentRoute: () => PrivateDashboardRoute,
  } as any)

const PublicAuthAuthLoginIndexLazyRoute =
  PublicAuthAuthLoginIndexLazyImport.update({
    id: '/auth/login/',
    path: '/auth/login/',
    getParentRoute: () => PublicAuthRoute,
  } as any).lazy(() =>
    import('./routes/_public/_auth/auth/login/index.lazy').then((d) => d.Route),
  )

const PublicAuthAuthForgotPasswordIndexLazyRoute =
  PublicAuthAuthForgotPasswordIndexLazyImport.update({
    id: '/auth/forgot-password/',
    path: '/auth/forgot-password/',
    getParentRoute: () => PublicAuthRoute,
  } as any).lazy(() =>
    import('./routes/_public/_auth/auth/forgot-password/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PublicAuthAuthResetPasswordIndexRoute =
  PublicAuthAuthResetPasswordIndexImport.update({
    id: '/auth/reset-password/',
    path: '/auth/reset-password/',
    getParentRoute: () => PublicAuthRoute,
  } as any).lazy(() =>
    import('./routes/_public/_auth/auth/reset-password/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateMeetingsIdReportIndexRoute =
  PrivateMeetingsIdReportIndexImport.update({
    id: '/meetings/$id/report/',
    path: '/meetings/$id/report/',
    getParentRoute: () => PrivateRoute,
  } as any).lazy(() =>
    import('./routes/_private/meetings/$id/report/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateDashboardBeneficiariesIdTabsRoute =
  PrivateDashboardBeneficiariesIdTabsImport.update({
    id: '/_tabs',
    getParentRoute: () => PrivateDashboardBeneficiariesIdRoute,
  } as any).lazy(() =>
    import('./routes/_private/_dashboard/beneficiaries/$id/_tabs.lazy').then(
      (d) => d.Route,
    ),
  )

const PublicAuthAuthRegisterTokenIndexLazyRoute =
  PublicAuthAuthRegisterTokenIndexLazyImport.update({
    id: '/auth/register/$token/',
    path: '/auth/register/$token/',
    getParentRoute: () => PublicAuthRoute,
  } as any).lazy(() =>
    import('./routes/_public/_auth/auth/register/$token/index.lazy').then(
      (d) => d.Route,
    ),
  )

const PrivateDashboardBeneficiariesIdTabsIndexLazyRoute =
  PrivateDashboardBeneficiariesIdTabsIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PrivateDashboardBeneficiariesIdTabsRoute,
  } as any).lazy(() =>
    import(
      './routes/_private/_dashboard/beneficiaries/$id/_tabs/index.lazy'
    ).then((d) => d.Route),
  )

const PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyRoute =
  PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyImport.update({
    id: '/tracking/',
    path: '/tracking/',
    getParentRoute: () => PrivateDashboardBeneficiariesIdTabsRoute,
  } as any).lazy(() =>
    import(
      './routes/_private/_dashboard/beneficiaries/$id/_tabs/tracking/index.lazy'
    ).then((d) => d.Route),
  )

const PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyRoute =
  PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyImport.update({
    id: '/telecare/',
    path: '/telecare/',
    getParentRoute: () => PrivateDashboardBeneficiariesIdTabsRoute,
  } as any).lazy(() =>
    import(
      './routes/_private/_dashboard/beneficiaries/$id/_tabs/telecare/index.lazy'
    ).then((d) => d.Route),
  )

const PrivateDashboardBeneficiariesIdTabsProgramIndexRoute =
  PrivateDashboardBeneficiariesIdTabsProgramIndexImport.update({
    id: '/program/',
    path: '/program/',
    getParentRoute: () => PrivateDashboardBeneficiariesIdTabsRoute,
  } as any).lazy(() =>
    import(
      './routes/_private/_dashboard/beneficiaries/$id/_tabs/program/index.lazy'
    ).then((d) => d.Route),
  )

const PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyRoute =
  PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyImport.update({
    id: '/program/new/',
    path: '/program/new/',
    getParentRoute: () => PrivateDashboardBeneficiariesIdTabsRoute,
  } as any).lazy(() =>
    import(
      './routes/_private/_dashboard/beneficiaries/$id/_tabs/program/new/index.lazy'
    ).then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicLazyImport
      parentRoute: typeof rootRoute
    }
    '/_private/_dashboard': {
      id: '/_private/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateDashboardImport
      parentRoute: typeof PrivateImport
    }
    '/_public/_auth': {
      id: '/_public/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicAuthImport
      parentRoute: typeof PublicLazyImport
    }
    '/_private/_dashboard/beneficiaries/$id': {
      id: '/_private/_dashboard/beneficiaries/$id'
      path: '/beneficiaries/$id'
      fullPath: '/beneficiaries/$id'
      preLoaderRoute: typeof PrivateDashboardBeneficiariesIdImport
      parentRoute: typeof PrivateDashboardImport
    }
    '/_private/_dashboard/meetings/': {
      id: '/_private/_dashboard/meetings/'
      path: '/meetings'
      fullPath: '/meetings'
      preLoaderRoute: typeof PrivateDashboardMeetingsIndexImport
      parentRoute: typeof PrivateDashboardImport
    }
    '/_private/meetings/$id/': {
      id: '/_private/meetings/$id/'
      path: '/meetings/$id'
      fullPath: '/meetings/$id'
      preLoaderRoute: typeof PrivateMeetingsIdIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_private/_dashboard/dashboard/': {
      id: '/_private/_dashboard/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof PrivateDashboardDashboardIndexLazyImport
      parentRoute: typeof PrivateDashboardImport
    }
    '/_private/_dashboard/profile/': {
      id: '/_private/_dashboard/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof PrivateDashboardProfileIndexLazyImport
      parentRoute: typeof PrivateDashboardImport
    }
    '/_private/auth/success/': {
      id: '/_private/auth/success/'
      path: '/auth/success'
      fullPath: '/auth/success'
      preLoaderRoute: typeof PrivateAuthSuccessIndexLazyImport
      parentRoute: typeof PrivateImport
    }
    '/_private/_dashboard/beneficiaries/$id/_tabs': {
      id: '/_private/_dashboard/beneficiaries/$id/_tabs'
      path: ''
      fullPath: '/beneficiaries/$id'
      preLoaderRoute: typeof PrivateDashboardBeneficiariesIdTabsImport
      parentRoute: typeof PrivateDashboardBeneficiariesIdImport
    }
    '/_private/meetings/$id/report/': {
      id: '/_private/meetings/$id/report/'
      path: '/meetings/$id/report'
      fullPath: '/meetings/$id/report'
      preLoaderRoute: typeof PrivateMeetingsIdReportIndexImport
      parentRoute: typeof PrivateImport
    }
    '/_public/_auth/auth/reset-password/': {
      id: '/_public/_auth/auth/reset-password/'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof PublicAuthAuthResetPasswordIndexImport
      parentRoute: typeof PublicAuthImport
    }
    '/_public/_auth/auth/forgot-password/': {
      id: '/_public/_auth/auth/forgot-password/'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof PublicAuthAuthForgotPasswordIndexLazyImport
      parentRoute: typeof PublicAuthImport
    }
    '/_public/_auth/auth/login/': {
      id: '/_public/_auth/auth/login/'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof PublicAuthAuthLoginIndexLazyImport
      parentRoute: typeof PublicAuthImport
    }
    '/_private/_dashboard/beneficiaries/$id/_tabs/': {
      id: '/_private/_dashboard/beneficiaries/$id/_tabs/'
      path: '/'
      fullPath: '/beneficiaries/$id/'
      preLoaderRoute: typeof PrivateDashboardBeneficiariesIdTabsIndexLazyImport
      parentRoute: typeof PrivateDashboardBeneficiariesIdTabsImport
    }
    '/_public/_auth/auth/register/$token/': {
      id: '/_public/_auth/auth/register/$token/'
      path: '/auth/register/$token'
      fullPath: '/auth/register/$token'
      preLoaderRoute: typeof PublicAuthAuthRegisterTokenIndexLazyImport
      parentRoute: typeof PublicAuthImport
    }
    '/_private/_dashboard/beneficiaries/$id/_tabs/program/': {
      id: '/_private/_dashboard/beneficiaries/$id/_tabs/program/'
      path: '/program'
      fullPath: '/beneficiaries/$id/program'
      preLoaderRoute: typeof PrivateDashboardBeneficiariesIdTabsProgramIndexImport
      parentRoute: typeof PrivateDashboardBeneficiariesIdTabsImport
    }
    '/_private/_dashboard/beneficiaries/$id/_tabs/telecare/': {
      id: '/_private/_dashboard/beneficiaries/$id/_tabs/telecare/'
      path: '/telecare'
      fullPath: '/beneficiaries/$id/telecare'
      preLoaderRoute: typeof PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyImport
      parentRoute: typeof PrivateDashboardBeneficiariesIdTabsImport
    }
    '/_private/_dashboard/beneficiaries/$id/_tabs/tracking/': {
      id: '/_private/_dashboard/beneficiaries/$id/_tabs/tracking/'
      path: '/tracking'
      fullPath: '/beneficiaries/$id/tracking'
      preLoaderRoute: typeof PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyImport
      parentRoute: typeof PrivateDashboardBeneficiariesIdTabsImport
    }
    '/_private/_dashboard/beneficiaries/$id/_tabs/program/new/': {
      id: '/_private/_dashboard/beneficiaries/$id/_tabs/program/new/'
      path: '/program/new'
      fullPath: '/beneficiaries/$id/program/new'
      preLoaderRoute: typeof PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyImport
      parentRoute: typeof PrivateDashboardBeneficiariesIdTabsImport
    }
  }
}

// Create and export the route tree

interface PrivateDashboardBeneficiariesIdTabsRouteChildren {
  PrivateDashboardBeneficiariesIdTabsIndexLazyRoute: typeof PrivateDashboardBeneficiariesIdTabsIndexLazyRoute
  PrivateDashboardBeneficiariesIdTabsProgramIndexRoute: typeof PrivateDashboardBeneficiariesIdTabsProgramIndexRoute
  PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyRoute: typeof PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyRoute
  PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyRoute: typeof PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyRoute
  PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyRoute: typeof PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyRoute
}

const PrivateDashboardBeneficiariesIdTabsRouteChildren: PrivateDashboardBeneficiariesIdTabsRouteChildren =
  {
    PrivateDashboardBeneficiariesIdTabsIndexLazyRoute:
      PrivateDashboardBeneficiariesIdTabsIndexLazyRoute,
    PrivateDashboardBeneficiariesIdTabsProgramIndexRoute:
      PrivateDashboardBeneficiariesIdTabsProgramIndexRoute,
    PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyRoute:
      PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyRoute,
    PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyRoute:
      PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyRoute,
    PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyRoute:
      PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyRoute,
  }

const PrivateDashboardBeneficiariesIdTabsRouteWithChildren =
  PrivateDashboardBeneficiariesIdTabsRoute._addFileChildren(
    PrivateDashboardBeneficiariesIdTabsRouteChildren,
  )

interface PrivateDashboardBeneficiariesIdRouteChildren {
  PrivateDashboardBeneficiariesIdTabsRoute: typeof PrivateDashboardBeneficiariesIdTabsRouteWithChildren
}

const PrivateDashboardBeneficiariesIdRouteChildren: PrivateDashboardBeneficiariesIdRouteChildren =
  {
    PrivateDashboardBeneficiariesIdTabsRoute:
      PrivateDashboardBeneficiariesIdTabsRouteWithChildren,
  }

const PrivateDashboardBeneficiariesIdRouteWithChildren =
  PrivateDashboardBeneficiariesIdRoute._addFileChildren(
    PrivateDashboardBeneficiariesIdRouteChildren,
  )

interface PrivateDashboardRouteChildren {
  PrivateDashboardBeneficiariesIdRoute: typeof PrivateDashboardBeneficiariesIdRouteWithChildren
  PrivateDashboardMeetingsIndexRoute: typeof PrivateDashboardMeetingsIndexRoute
  PrivateDashboardDashboardIndexLazyRoute: typeof PrivateDashboardDashboardIndexLazyRoute
  PrivateDashboardProfileIndexLazyRoute: typeof PrivateDashboardProfileIndexLazyRoute
}

const PrivateDashboardRouteChildren: PrivateDashboardRouteChildren = {
  PrivateDashboardBeneficiariesIdRoute:
    PrivateDashboardBeneficiariesIdRouteWithChildren,
  PrivateDashboardMeetingsIndexRoute: PrivateDashboardMeetingsIndexRoute,
  PrivateDashboardDashboardIndexLazyRoute:
    PrivateDashboardDashboardIndexLazyRoute,
  PrivateDashboardProfileIndexLazyRoute: PrivateDashboardProfileIndexLazyRoute,
}

const PrivateDashboardRouteWithChildren =
  PrivateDashboardRoute._addFileChildren(PrivateDashboardRouteChildren)

interface PrivateRouteChildren {
  PrivateDashboardRoute: typeof PrivateDashboardRouteWithChildren
  PrivateMeetingsIdIndexRoute: typeof PrivateMeetingsIdIndexRoute
  PrivateAuthSuccessIndexLazyRoute: typeof PrivateAuthSuccessIndexLazyRoute
  PrivateMeetingsIdReportIndexRoute: typeof PrivateMeetingsIdReportIndexRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateDashboardRoute: PrivateDashboardRouteWithChildren,
  PrivateMeetingsIdIndexRoute: PrivateMeetingsIdIndexRoute,
  PrivateAuthSuccessIndexLazyRoute: PrivateAuthSuccessIndexLazyRoute,
  PrivateMeetingsIdReportIndexRoute: PrivateMeetingsIdReportIndexRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

interface PublicAuthRouteChildren {
  PublicAuthAuthResetPasswordIndexRoute: typeof PublicAuthAuthResetPasswordIndexRoute
  PublicAuthAuthForgotPasswordIndexLazyRoute: typeof PublicAuthAuthForgotPasswordIndexLazyRoute
  PublicAuthAuthLoginIndexLazyRoute: typeof PublicAuthAuthLoginIndexLazyRoute
  PublicAuthAuthRegisterTokenIndexLazyRoute: typeof PublicAuthAuthRegisterTokenIndexLazyRoute
}

const PublicAuthRouteChildren: PublicAuthRouteChildren = {
  PublicAuthAuthResetPasswordIndexRoute: PublicAuthAuthResetPasswordIndexRoute,
  PublicAuthAuthForgotPasswordIndexLazyRoute:
    PublicAuthAuthForgotPasswordIndexLazyRoute,
  PublicAuthAuthLoginIndexLazyRoute: PublicAuthAuthLoginIndexLazyRoute,
  PublicAuthAuthRegisterTokenIndexLazyRoute:
    PublicAuthAuthRegisterTokenIndexLazyRoute,
}

const PublicAuthRouteWithChildren = PublicAuthRoute._addFileChildren(
  PublicAuthRouteChildren,
)

interface PublicLazyRouteChildren {
  PublicAuthRoute: typeof PublicAuthRouteWithChildren
}

const PublicLazyRouteChildren: PublicLazyRouteChildren = {
  PublicAuthRoute: PublicAuthRouteWithChildren,
}

const PublicLazyRouteWithChildren = PublicLazyRoute._addFileChildren(
  PublicLazyRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof PublicAuthRouteWithChildren
  '/beneficiaries/$id': typeof PrivateDashboardBeneficiariesIdTabsRouteWithChildren
  '/meetings': typeof PrivateDashboardMeetingsIndexRoute
  '/meetings/$id': typeof PrivateMeetingsIdIndexRoute
  '/dashboard': typeof PrivateDashboardDashboardIndexLazyRoute
  '/profile': typeof PrivateDashboardProfileIndexLazyRoute
  '/auth/success': typeof PrivateAuthSuccessIndexLazyRoute
  '/meetings/$id/report': typeof PrivateMeetingsIdReportIndexRoute
  '/auth/reset-password': typeof PublicAuthAuthResetPasswordIndexRoute
  '/auth/forgot-password': typeof PublicAuthAuthForgotPasswordIndexLazyRoute
  '/auth/login': typeof PublicAuthAuthLoginIndexLazyRoute
  '/beneficiaries/$id/': typeof PrivateDashboardBeneficiariesIdTabsIndexLazyRoute
  '/auth/register/$token': typeof PublicAuthAuthRegisterTokenIndexLazyRoute
  '/beneficiaries/$id/program': typeof PrivateDashboardBeneficiariesIdTabsProgramIndexRoute
  '/beneficiaries/$id/telecare': typeof PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyRoute
  '/beneficiaries/$id/tracking': typeof PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyRoute
  '/beneficiaries/$id/program/new': typeof PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof PublicAuthRouteWithChildren
  '/beneficiaries/$id': typeof PrivateDashboardBeneficiariesIdTabsIndexLazyRoute
  '/meetings': typeof PrivateDashboardMeetingsIndexRoute
  '/meetings/$id': typeof PrivateMeetingsIdIndexRoute
  '/dashboard': typeof PrivateDashboardDashboardIndexLazyRoute
  '/profile': typeof PrivateDashboardProfileIndexLazyRoute
  '/auth/success': typeof PrivateAuthSuccessIndexLazyRoute
  '/meetings/$id/report': typeof PrivateMeetingsIdReportIndexRoute
  '/auth/reset-password': typeof PublicAuthAuthResetPasswordIndexRoute
  '/auth/forgot-password': typeof PublicAuthAuthForgotPasswordIndexLazyRoute
  '/auth/login': typeof PublicAuthAuthLoginIndexLazyRoute
  '/auth/register/$token': typeof PublicAuthAuthRegisterTokenIndexLazyRoute
  '/beneficiaries/$id/program': typeof PrivateDashboardBeneficiariesIdTabsProgramIndexRoute
  '/beneficiaries/$id/telecare': typeof PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyRoute
  '/beneficiaries/$id/tracking': typeof PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyRoute
  '/beneficiaries/$id/program/new': typeof PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_private': typeof PrivateRouteWithChildren
  '/_public': typeof PublicLazyRouteWithChildren
  '/_private/_dashboard': typeof PrivateDashboardRouteWithChildren
  '/_public/_auth': typeof PublicAuthRouteWithChildren
  '/_private/_dashboard/beneficiaries/$id': typeof PrivateDashboardBeneficiariesIdRouteWithChildren
  '/_private/_dashboard/meetings/': typeof PrivateDashboardMeetingsIndexRoute
  '/_private/meetings/$id/': typeof PrivateMeetingsIdIndexRoute
  '/_private/_dashboard/dashboard/': typeof PrivateDashboardDashboardIndexLazyRoute
  '/_private/_dashboard/profile/': typeof PrivateDashboardProfileIndexLazyRoute
  '/_private/auth/success/': typeof PrivateAuthSuccessIndexLazyRoute
  '/_private/_dashboard/beneficiaries/$id/_tabs': typeof PrivateDashboardBeneficiariesIdTabsRouteWithChildren
  '/_private/meetings/$id/report/': typeof PrivateMeetingsIdReportIndexRoute
  '/_public/_auth/auth/reset-password/': typeof PublicAuthAuthResetPasswordIndexRoute
  '/_public/_auth/auth/forgot-password/': typeof PublicAuthAuthForgotPasswordIndexLazyRoute
  '/_public/_auth/auth/login/': typeof PublicAuthAuthLoginIndexLazyRoute
  '/_private/_dashboard/beneficiaries/$id/_tabs/': typeof PrivateDashboardBeneficiariesIdTabsIndexLazyRoute
  '/_public/_auth/auth/register/$token/': typeof PublicAuthAuthRegisterTokenIndexLazyRoute
  '/_private/_dashboard/beneficiaries/$id/_tabs/program/': typeof PrivateDashboardBeneficiariesIdTabsProgramIndexRoute
  '/_private/_dashboard/beneficiaries/$id/_tabs/telecare/': typeof PrivateDashboardBeneficiariesIdTabsTelecareIndexLazyRoute
  '/_private/_dashboard/beneficiaries/$id/_tabs/tracking/': typeof PrivateDashboardBeneficiariesIdTabsTrackingIndexLazyRoute
  '/_private/_dashboard/beneficiaries/$id/_tabs/program/new/': typeof PrivateDashboardBeneficiariesIdTabsProgramNewIndexLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/beneficiaries/$id'
    | '/meetings'
    | '/meetings/$id'
    | '/dashboard'
    | '/profile'
    | '/auth/success'
    | '/meetings/$id/report'
    | '/auth/reset-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/beneficiaries/$id/'
    | '/auth/register/$token'
    | '/beneficiaries/$id/program'
    | '/beneficiaries/$id/telecare'
    | '/beneficiaries/$id/tracking'
    | '/beneficiaries/$id/program/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/beneficiaries/$id'
    | '/meetings'
    | '/meetings/$id'
    | '/dashboard'
    | '/profile'
    | '/auth/success'
    | '/meetings/$id/report'
    | '/auth/reset-password'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register/$token'
    | '/beneficiaries/$id/program'
    | '/beneficiaries/$id/telecare'
    | '/beneficiaries/$id/tracking'
    | '/beneficiaries/$id/program/new'
  id:
    | '__root__'
    | '/'
    | '/_private'
    | '/_public'
    | '/_private/_dashboard'
    | '/_public/_auth'
    | '/_private/_dashboard/beneficiaries/$id'
    | '/_private/_dashboard/meetings/'
    | '/_private/meetings/$id/'
    | '/_private/_dashboard/dashboard/'
    | '/_private/_dashboard/profile/'
    | '/_private/auth/success/'
    | '/_private/_dashboard/beneficiaries/$id/_tabs'
    | '/_private/meetings/$id/report/'
    | '/_public/_auth/auth/reset-password/'
    | '/_public/_auth/auth/forgot-password/'
    | '/_public/_auth/auth/login/'
    | '/_private/_dashboard/beneficiaries/$id/_tabs/'
    | '/_public/_auth/auth/register/$token/'
    | '/_private/_dashboard/beneficiaries/$id/_tabs/program/'
    | '/_private/_dashboard/beneficiaries/$id/_tabs/telecare/'
    | '/_private/_dashboard/beneficiaries/$id/_tabs/tracking/'
    | '/_private/_dashboard/beneficiaries/$id/_tabs/program/new/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  PublicLazyRoute: typeof PublicLazyRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRoute: PrivateRouteWithChildren,
  PublicLazyRoute: PublicLazyRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_private",
        "/_public"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_private": {
      "filePath": "_private.tsx",
      "children": [
        "/_private/_dashboard",
        "/_private/meetings/$id/",
        "/_private/auth/success/",
        "/_private/meetings/$id/report/"
      ]
    },
    "/_public": {
      "filePath": "_public.lazy.tsx",
      "children": [
        "/_public/_auth"
      ]
    },
    "/_private/_dashboard": {
      "filePath": "_private/_dashboard.tsx",
      "parent": "/_private",
      "children": [
        "/_private/_dashboard/beneficiaries/$id",
        "/_private/_dashboard/meetings/",
        "/_private/_dashboard/dashboard/",
        "/_private/_dashboard/profile/"
      ]
    },
    "/_public/_auth": {
      "filePath": "_public/_auth.tsx",
      "parent": "/_public",
      "children": [
        "/_public/_auth/auth/reset-password/",
        "/_public/_auth/auth/forgot-password/",
        "/_public/_auth/auth/login/",
        "/_public/_auth/auth/register/$token/"
      ]
    },
    "/_private/_dashboard/beneficiaries/$id": {
      "filePath": "_private/_dashboard/beneficiaries/$id.tsx",
      "parent": "/_private/_dashboard",
      "children": [
        "/_private/_dashboard/beneficiaries/$id/_tabs"
      ]
    },
    "/_private/_dashboard/meetings/": {
      "filePath": "_private/_dashboard/meetings/index.tsx",
      "parent": "/_private/_dashboard"
    },
    "/_private/meetings/$id/": {
      "filePath": "_private/meetings/$id/index.tsx",
      "parent": "/_private"
    },
    "/_private/_dashboard/dashboard/": {
      "filePath": "_private/_dashboard/dashboard/index.lazy.tsx",
      "parent": "/_private/_dashboard"
    },
    "/_private/_dashboard/profile/": {
      "filePath": "_private/_dashboard/profile/index.lazy.tsx",
      "parent": "/_private/_dashboard"
    },
    "/_private/auth/success/": {
      "filePath": "_private/auth/success/index.lazy.tsx",
      "parent": "/_private"
    },
    "/_private/_dashboard/beneficiaries/$id/_tabs": {
      "filePath": "_private/_dashboard/beneficiaries/$id/_tabs.tsx",
      "parent": "/_private/_dashboard/beneficiaries/$id",
      "children": [
        "/_private/_dashboard/beneficiaries/$id/_tabs/",
        "/_private/_dashboard/beneficiaries/$id/_tabs/program/",
        "/_private/_dashboard/beneficiaries/$id/_tabs/telecare/",
        "/_private/_dashboard/beneficiaries/$id/_tabs/tracking/",
        "/_private/_dashboard/beneficiaries/$id/_tabs/program/new/"
      ]
    },
    "/_private/meetings/$id/report/": {
      "filePath": "_private/meetings/$id/report/index.tsx",
      "parent": "/_private"
    },
    "/_public/_auth/auth/reset-password/": {
      "filePath": "_public/_auth/auth/reset-password/index.tsx",
      "parent": "/_public/_auth"
    },
    "/_public/_auth/auth/forgot-password/": {
      "filePath": "_public/_auth/auth/forgot-password/index.lazy.tsx",
      "parent": "/_public/_auth"
    },
    "/_public/_auth/auth/login/": {
      "filePath": "_public/_auth/auth/login/index.lazy.tsx",
      "parent": "/_public/_auth"
    },
    "/_private/_dashboard/beneficiaries/$id/_tabs/": {
      "filePath": "_private/_dashboard/beneficiaries/$id/_tabs/index.lazy.tsx",
      "parent": "/_private/_dashboard/beneficiaries/$id/_tabs"
    },
    "/_public/_auth/auth/register/$token/": {
      "filePath": "_public/_auth/auth/register/$token/index.lazy.tsx",
      "parent": "/_public/_auth"
    },
    "/_private/_dashboard/beneficiaries/$id/_tabs/program/": {
      "filePath": "_private/_dashboard/beneficiaries/$id/_tabs/program/index.tsx",
      "parent": "/_private/_dashboard/beneficiaries/$id/_tabs"
    },
    "/_private/_dashboard/beneficiaries/$id/_tabs/telecare/": {
      "filePath": "_private/_dashboard/beneficiaries/$id/_tabs/telecare/index.lazy.tsx",
      "parent": "/_private/_dashboard/beneficiaries/$id/_tabs"
    },
    "/_private/_dashboard/beneficiaries/$id/_tabs/tracking/": {
      "filePath": "_private/_dashboard/beneficiaries/$id/_tabs/tracking/index.lazy.tsx",
      "parent": "/_private/_dashboard/beneficiaries/$id/_tabs"
    },
    "/_private/_dashboard/beneficiaries/$id/_tabs/program/new/": {
      "filePath": "_private/_dashboard/beneficiaries/$id/_tabs/program/new/index.lazy.tsx",
      "parent": "/_private/_dashboard/beneficiaries/$id/_tabs"
    }
  }
}
ROUTE_MANIFEST_END */
